// Hilfsfunktionen für deutsche Datumsangaben (Format: TT.MM.JJJJ)

export function parseGermanDate(str) {
  const [d, m, y] = String(str).split(".").map(Number);
  return new Date(y, m - 1, d);
}

export function startOfToday() {
  const t = new Date();
  t.setHours(0, 0, 0, 0);
  return t;
}

// Termin ist heute oder in der Zukunft
export function isUpcoming(str) {
  return parseGermanDate(str) >= startOfToday();
}

// Nur kommende Termine, aufsteigend sortiert
export function upcoming(items, key = "date") {
  return items
    .filter((i) => isUpcoming(i[key]))
    .sort((a, b) => parseGermanDate(a[key]) - parseGermanDate(b[key]));
}

export function monthShort(dateStr) {
  const months = [
    "Jan", "Feb", "Mär", "Apr", "Mai", "Jun",
    "Jul", "Aug", "Sep", "Okt", "Nov", "Dez",
  ];
  return months[parseInt(String(dateStr).split(".")[1], 10) - 1] || "";
}
